import React, { useEffect, useState } from 'react';
import { Setting } from '../../services/settingServices';

const Settings = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchVersion = async () => {
        try {
            const res = await Setting.getVersion();
            const versionList = res.data;
            console.log(versionList, 'versionist');
            if (Array.isArray(versionList)) {
                setData(versionList);
            }
        } catch (err) {
            console.error('Failed to fetch version info', err);
        }
    };

    console.log(data, 'data');

    const handleChange = (index, field, value) => {
        const updated = [...data];
        updated[index][field] = value;
        setData(updated);
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);
            for (let item of data) {
                await Setting.updateVersion(item); // assumes item has valid id
            }
        } catch (err) {
            console.error('Update failed', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVersion();
    }, []);

    return (
        <div className="max-w-4xl mx-auto mt-10 px-4">
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-6">App Version Settings</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {data.map((item, index) => (
                        <div
                            key={item.id || item.platform}
                            className="border border-gray-200 rounded-xl p-4 bg-gray-50"
                        >
                            <h3 className="text-lg font-medium mb-4 capitalize">{item.platform}</h3>

                            <div className="mb-3">
                                <label className="block text-sm text-gray-700 mb-1">Version</label>
                                <input
                                    type="text"
                                    value={item.version}
                                    onChange={(e) => handleChange(index, 'version', e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                />
                            </div>

                            <div className="mb-3">
                                <label className="block text-sm text-gray-700 mb-1">App Link</label>
                                <input
                                    type="text"
                                    value={item.applink}
                                    onChange={(e) => handleChange(index, 'applink', e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className={`mt-6 px-6 py-2 rounded-lg text-white font-medium transition ${
                        loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                    {loading ? 'Updating...' : 'Update Versions'}
                </button>
            </div>
        </div>
    );
};

export default Settings;
